import React, { useContext } from 'react'
import { JourneyContext } from '../context/journeyContext'
import { ConditionContext } from '../context/conditionContext'
import DOMPurify from 'dompurify'
import { getDynamicTextContent } from '../services/dynamicHeadings'
import { SectionContext } from '../context/sectionContext'
import { ErrorContext } from '../context/errorContext'

const feetToCms = (feet, inches) => {
   const feetValue = Number(feet) || 0
   const inchesValue = Number(inches) || 0
   return Math.round(feetValue * 30.48 + inchesValue * 2.54)
}


export default function ComponentTextParagraph(props) {
   const [conditionState, setConditionState] = useContext(ConditionContext)
   const [journeyState] = useContext(JourneyContext)
   const [sectionState, setSectionState] = useContext(SectionContext)
   const [, setErrorState] = useContext(ErrorContext)

   if (
      props.sectionId === "healthAndLifeStyleDetailSection" &&
      props.data?.formControlKey === "textor"
   ) {
      const heightUnit =
         sectionState.sectionData?.heightUnit ||
         (sectionState.sectionData?.disableInInches
            ? "cm"
            : sectionState.sectionData?.disableCms
               ? "ft"
               : sectionState.sectionData?.healthAndLifeStyleHeight &&
                 !sectionState.sectionData?.heightInFeets &&
                 !sectionState.sectionData?.heightInInches
                  ? "cm"
                  : "ft")

      const updateHeightUnit = nextUnit => {
         const currentCms = sectionState.sectionData?.healthAndLifeStyleHeight || ""
         const currentFeet = sectionState.sectionData?.heightInFeets || ""
         const currentInches = sectionState.sectionData?.heightInInches || ""
         let nextCms = currentCms
         let nextFeet = currentFeet
         let nextInches = currentInches

         if (nextUnit === "cm" && currentFeet && currentInches) {
            nextCms = String(feetToCms(currentFeet, currentInches))
         }

         if (nextUnit === "ft" && currentCms) {
            let feet = Math.floor(currentCms / 30.48)
            let inches = Math.round((currentCms / 30.48 - feet) * 12)

            if (inches === 12) {
               feet = feet + 1
               inches = 0
            }

            nextFeet = String(feet)
            nextInches = String(inches)
         }

         setSectionState(prev => ({
            ...prev,
            sectionData: {
               ...prev.sectionData,
               heightUnit: nextUnit,
               healthAndLifeStyleHeight: nextCms,
               heightInFeets: nextFeet,
               heightInInches: nextInches,
               disableCms: nextUnit === "ft",
               disableInInches: nextUnit === "cm",
            },
         }))

         setConditionState(prev => ({
            ...prev,
            [`${props.pageId}.${props.sectionId}.healthAndLifeStyleHeight`]: nextCms,
            [`${props.pageId}.${props.sectionId}.heightInFeets`]: nextFeet,
            [`${props.pageId}.${props.sectionId}.heightInInches`]: nextInches,
         }))

         setErrorState(prev => ({
            ...prev,
            healthAndLifeStyleHeight: "",
            heightInFeets: "",
            heightInInches: "",
         }))
      }

      return (
         <>
            <style>{`
               .height-unit-toggle-row {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  width: 100%;
                  margin: 4px 0 8px;
               }

               .height-unit-toggle {
                  display: inline-flex;
                  overflow: hidden;
                  border: 1px solid #d0d0d0;
                  border-radius: 10px;
                  background: #fff;
               }

               .height-unit-toggle button {
                  border: 0;
                  background: #fff;
                  color: #505050;
                  padding: 8px 14px;
                  font-size: 12px;
                  font-weight: 600;
                  cursor: pointer;
                  text-transform: uppercase;
               }

               .height-unit-toggle button.active {
                  background: var(--lumiq-secondary);
                  color: #fff;
               }

               @media (max-width: 767px) {
                  .height-unit-toggle-row {
                     justify-content: flex-start;
                     margin-bottom: 10px;
                  }

                  .health-height-ft-wrap,
                  .health-height-in-wrap {
                     width: 50%;
                     float: left;
                  }

                  .health-height-ft-wrap {
                     padding-right: 6px;
                  }

                  .health-height-in-wrap {
                     padding-left: 6px;
                  }

                  .health-height-cm-wrap,
                  .health-height-weight-wrap,
                  .health-height-toggle-wrap {
                     width: 100%;
                     float: left;
                  }
               }
            `}</style>
            <div className="height-unit-toggle-row">
               <div className="height-unit-toggle">
                  <button
                     type="button"
                     className={heightUnit === "ft" ? "active" : ""}
                     onClick={() => updateHeightUnit("ft")}
                  >
                     FT
                  </button>
                  <button
                     type="button"
                     className={heightUnit === "cm" ? "active" : ""}
                     onClick={() => updateHeightUnit("cm")}
                  >
                     CM
                  </button>
               </div>
            </div>
         </>
      )
   }

   const sanitizedContent = DOMPurify.sanitize(
      getDynamicTextContent({
         sectionId: props.sectionId,
         content: props.data.Content,
         conditionState,
         journeyState,
         sections: props.sections,
      })
   )

    return (
         <>
            <label className="inp-label">
            </label>
            <div dangerouslySetInnerHTML={{"__html":sanitizedContent}}></div>
         </>
        )

}
